module.exports = __webpack_public_path__ + "static/stairlift2-2f46c063690e6d4ec8fc12cf13f662fa.jpg";